import * as httpx from '../httpx.js';

// DOM ELEMENTS
const companyDataForm = document.querySelector('.form-company-data');
const addCompany = document.querySelector('.form-add-company');

// Helper function to convert file to base64
const convertToBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

// Setup company data form
function setupCompanyDataForm() {
  if (companyDataForm)
    companyDataForm.addEventListener('submit', async e => {
      e.preventDefault();
      const url = '/api/v1/companies/updateMy';
      const method = 'PATCH';
      const data = {};
      data.companyName = document.getElementById('name').value;
      data.adress = document.getElementById('adress').value;

      const photoFile = document.getElementById('photo').files[0];
      if (photoFile) {
        try {
          data.photo = await convertToBase64(photoFile);
        } catch (err) {
          showAlert('error', 'Error processing image');
          return;
        }
      }

      await httpx.updateOrCreateRecord(data, url, method, 'Company');
    });
}

// Setup add company form
function setupAddCompany() {
  if (addCompany)
    addCompany.addEventListener('submit', async e => {
      e.preventDefault();
      const url = '/api/v1/companies/createCompany';
      const method = 'POST';
      const data = {};
      data.companyName = document.getElementById('name').value;
      data.adress = document.getElementById('adress').value;
      data.services = document.getElementById('services').value;

      const success = await httpx.updateOrCreateRecord(
        data,
        url,
        method,
        'Company',
      );
      if (success === 'succes') {
        document.querySelector('.add__content').classList.add('hidden');
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }
    });
}

// Initialize all company functionality
function setupCompany() {
  setupCompanyDataForm();
  setupAddCompany();
}

export { setupCompany };
